export default __webpack_public_path__ + "static/media/timer.a2e8fc14.png";